// Premises utils
// --------------------------------------------------------

let utils = {}
// Add extra properties to original Premises
utils.parsePremises = (premises, getters) =>
  premises.forEach(premise => parsePremise(premise, getters))
const parsePremise = (premise, getters) => {
  premise.color = getters.getActorByID(premise.actorId).color
  premise.currentUser.favorited = !!premise.currentUser.favorited // make sure it's boolean
  if (!premise.lastComment) {
    premise.lastComment = '1981-11-26T00:00:00.000Z' // very old
  }
  premise.lastActivityAt = premise.updatedAt
  if (premise.lastComment > premise.updatedAt) {
    premise.lastActivityAt = premise.lastComment
  }
  premise.breadcrumb = premise.parentsId.map(id => {
    let actor = getters.getActorByID(id)
    return {
      name: actor.name,
      pathArr: actor.pathArr
    }
  })
}

export default utils
